import { usePermissions } from 'src/hooks/usePermissions';

import { ContentContainer } from '../src/components/ContentContainer';
import { ConnectWalletPaper } from '../src/components/ConnectWalletPaper';
import { MainLayout } from '../src/layouts/MainLayout';
import { useWeb3Context } from '../src/libs/hooks/useWeb3Context';
import { LeverageTopPanel } from '../src/modules/dashboard/LeverageTopPanel';
import { LeverageContentWrapper } from '../src/modules/leverage/LeverageContentWrapper';

export default function Leverage() {
  const { currentAccount, loading } = useWeb3Context();
  const { isPermissionsLoading } = usePermissions();

  return (
    <>
      <LeverageTopPanel />
      <ContentContainer>
        {currentAccount && !isPermissionsLoading ? (
          <LeverageContentWrapper />
        ) : (
          <ConnectWalletPaper loading={loading} />
        )}
      </ContentContainer>
    </>
  );
}

Leverage.getLayout = function getLayout(page: React.ReactElement) {
  return <MainLayout>{page}</MainLayout>;
};
